import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h6m3 0h1.5m3 0h.5","key":"svg-0"}],["path",{"d":"M5 12l6 6","key":"svg-1"}],["path",{"d":"M5 12l6 -6","key":"svg-2"}]]

const IconArrowLeftDashed = createReactComponent('outline', 'arrow-left-dashed', 'ArrowLeftDashed', __iconNode);

export default IconArrowLeftDashed;